import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_shipments",
  ref: "addShipments",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_inventory_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_inventory_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_inventory_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_inventory_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-7" }
const _hoisted_13 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = {
  key: 0,
  class: "form-group mb-7"
}
const _hoisted_19 = {
  key: 1,
  class: "form-group mb-7"
}
const _hoisted_20 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-7" }
const _hoisted_23 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_24 = { class: "modal-footer flex-center" }
const _hoisted_25 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_26 = {
  class: "btn btn-lg btn-primary",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_pre_stock_out_list"
}
const _hoisted_27 = { class: "indicator-label" }
const _hoisted_28 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_29 = { class: "indicator-progress" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_31 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_32 = { class: "indicator-label" }
const _hoisted_33 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_34 = { class: "indicator-progress" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_addPreStockOutList = _resolveComponent("addPreStockOutList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add")) + _toDisplayString(_ctx.t("common.shipments")), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createVNode(_component_el_form, {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("shipments.type")), 1),
                        _createVNode(_component_el_form_item, { prop: "shipment_type" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.shipment_type,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.shipment_type) = $event)),
                              filterable: "",
                              clearable: "",
                              style: {"width":"100%"},
                              placeholder: _ctx.t('common.plsSelect')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.shipment_type, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value,
                                    disabled: 
                            (item.value === '1' &&
                              _ctx.props.fulfillment_order_id == 0) ||
                            (_ctx.props.fulfillment_order_id != 0 &&
                              _ctx.props.fulfillment_order_type == 2 &&
                              item.value === '1')
                          
                                  }, null, 8, ["label", "value", "disabled"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("shipments.serviceProvider")), 1),
                        _createVNode(_component_el_form_item, { prop: "service_provider" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.service_provider,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.service_provider) = $event)),
                              filterable: "",
                              clearable: "",
                              placeholder: _ctx.t('common.plsSelect'),
                              style: {"width":"100%"},
                              onChange: _ctx.serviceProviderCHange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.service_provider, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.formData.service_provider != '-1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["fs-6 fw-bold mb-2", {
                        required: _ctx.formData.shipment_type == '1',
                      }])
                            }, _toDisplayString(_ctx.t("fulfillmentOrder.shipmentTrackingNo")), 3),
                            _createVNode(_component_el_form_item, { prop: "tracking_no" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.tracking_no,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.tracking_no) = $event)),
                                  modelModifiers: { trim: true },
                                  type: "text",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("fulfillmentOrder.pickUpBy")), 1),
                            _createVNode(_component_el_form_item, { prop: "pick_up_by" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.pick_up_by,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.pick_up_by) = $event)),
                                  type: "text",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("fulfillmentOrder.nextDestination")), 1),
                        _withDirectives(_createVNode(_component_el_form_item, { prop: "country" }, null, 512), [
                          [_vShow, 0]
                        ]),
                        _createVNode(_component_el_form_item, { prop: "destination_warehouse_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.destination_warehouse_id,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.destination_warehouse_id) = $event)),
                              filterable: "",
                              clearable: "",
                              onChange: _ctx.warehouseChanage,
                              placeholder: _ctx.t('common.plsSelect')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouse, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-light me-3",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                }, [
                  _createElementVNode("span", _hoisted_25, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.next")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_29, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_30
                  ])
                ], 512), [
                  [_vShow, !_ctx.isDisabledSubmit]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_35
                  ])
                ], 512), [
                  [_vShow, _ctx.isDisabledSubmit]
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ], 512),
    _createVNode(_component_addPreStockOutList, {
      fulfillment_order_id: _ctx.props.fulfillment_order_id,
      fulfillment_order_number: _ctx.props.fulfillment_order_number,
      fulfillment_order_type: _ctx.props.fulfillment_order_type,
      custom_declaration_by: String(_ctx.props.custom_declaration_by),
      submitData: _ctx.formData,
      show: _ctx.showStockOut,
      onUpdateList: _ctx.updateList,
      onResetForm: _ctx.resetShow
    }, null, 8, ["fulfillment_order_id", "fulfillment_order_number", "fulfillment_order_type", "custom_declaration_by", "submitData", "show", "onUpdateList", "onResetForm"])
  ], 64))
}